import { useGlobalContext } from '../../../contexts/GlobalContext';
import '../../../styles/pages/dashboard/components/TopOfPages.scss';
import { useTranslations } from '../../../data/fetch/fetchAdditionalApi';
import { InfoTextComponent, SubTitleComponent } from '../../../components/ui/TextComponents';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

function TopOfPages({ subtitle, info, textlink, link, emailtextlink, emaillink, textBtn, textBtnFunc, emailBtn, emailBtnFunc, backlink, contractlink, domainsearch, emailsearch, contractsearch, placeholderdomain, placeholdercontract }) {

    // router options

    const path = useLocation();
    const { lang } = useParams();
    const navigate = useNavigate();
    const [param] = useSearchParams();

    // API options

    const dataTranslations = useTranslations(lang);

    // search options

    function byDomianSearch(e) {
        e.preventDefault();

        if (e.target.value) {
            navigate(`?search=${e.target.value}`);
        } else {
            navigate(backlink)
        }
    };

    function byDomianSearchSubmit(e) {
        e.preventDefault();

        if (e.target[0].value) {
            navigate(`?search=${e.target[0].value}`);
        } else {
            navigate(backlink)
        }

        window.scrollTo(0, 0)
    };

    function byEmailSearch(e) {
        e.preventDefault();

        if (e.target.value) {
            navigate(`?email=${e.target.value}`);
        } else {
            navigate(backlink)
        }
    };

    function byEmailSearchSubmit(e) {
        e.preventDefault();

        if (e.target[0].value) {
            navigate(`?email=${e.target[0].value}`);
        } else {
            navigate(backlink)
        }

        window.scrollTo(0, 0)
    };

    function byContractSearchSubmit(e) {
        e.preventDefault();
        window.scrollTo(0, 0);
        navigate(`${contractlink}?search=${e.target[0].value}`);
    };

    // useContext hook options

    const { darkness } = useGlobalContext();

    return (
        <div className={`TopOfPages gap-2 ${darkness ? "DarkTopOfPages" : ""}`}>
            <SubTitleComponent title={subtitle} disabled={false} />
            {info &&
                <InfoTextComponent text={info} disabled={false} />
            }
            {domainsearch &&
                <div className="top gap-2">
                    <form onSubmit={byDomianSearchSubmit} className="searching">
                        <input type="text" required name='by-domain' className='search_input big-text pd-05 round-05' placeholder={`${dataTranslations?.data?.data[placeholderdomain]}...`} value={param.get('search') ? param.get('search') : ""} onChange={(e) => byDomianSearch(e)} />
                        <button type="submit" className='search_btn pd-05 round-05 text'><i className="fa fa-search"></i></button>
                    </form>
                    {textlink &&
                        <Link to={link} className="text_link big-text">{dataTranslations?.data?.data[textlink]}</Link>
                        // <Link to={link} className="action_btn gap-05 big-text pd-05 round-05 op-08">{dataTranslations?.data?.data[textlink]} <i className="fa fa-arrow-right"></i></Link>
                    }
                    {textBtn &&
                        <button className="action_btn big-text pd-05 round-05 op-08" onClick={textBtnFunc}>{dataTranslations?.data?.data[textBtn]}</button>
                    }
                </div>
            }
            {emailsearch &&
                <div className="top gap-2">
                    <form onSubmit={byEmailSearchSubmit} className="searching">
                        <input type="email" required name='by-email' className='search_input big-text pd-05 round-05' placeholder={`${dataTranslations?.data?.data["enter_email"]}`} value={param.get('email') ? param.get('email') : ""} onChange={(e) => byEmailSearch(e)} />
                        <button type="submit" className='search_btn pd-05 round-05 text'><i className="fa fa-search"></i></button>
                    </form>
                    {emaillink &&
                        <Link to={emaillink} className="text_link big-text">{dataTranslations?.data?.data[emailtextlink]}</Link>
                        // <Link to={emaillink} className="action_btn gap-05 big-text pd-05 round-05 op-08">{dataTranslations?.data?.data[emailtextlink]} <i className="fa fa-arrow-right"></i></Link>
                    }
                    {emailBtn &&
                        <button className="action_btn big-text pd-05 round-05 op-08" onClick={emailBtnFunc}>{dataTranslations?.data?.data[emailBtn]}</button>
                    }
                </div>
            }
            {contractsearch &&
                <div className="top gap-2">
                    <form onSubmit={byContractSearchSubmit} className="searching">
                        <input type="text" required name='by-domain' className='search_input big-text pd-05 round-05' placeholder={`${dataTranslations?.data?.data[placeholdercontract]}...`} />
                        <button type="submit" className='search_btn pd-05 round-05 text'><i className="fa fa-search"></i></button>
                    </form>
                    {textlink &&
                        <Link to={link} className="text_link big-text">{dataTranslations?.data?.data[textlink]}</Link>
                    }
                </div>
            }
            <div className="search_area gap-2">
                {param.get('search') &&
                    <div className="search_result big-text" onClick={() => navigate(decodeURIComponent(path.search) == `?search=${param.get('search')}` ? backlink : `${decodeURIComponent(path?.search)?.replace(`search=${param.get('search')}&`, ``)}`)}>{param.get('search')} <i className="fa fa-times"></i></div>
                }
                {param.get('email') &&
                    <div className="search_result big-text" onClick={() => navigate(decodeURIComponent(path.search) == `?email=${param.get('email')}` ? backlink : `${decodeURIComponent(path?.search)?.replace(`email=${param.get('email')}&`, ``)}`)}>{param.get('email')} <i className="fa fa-times"></i></div>
                }
                {param.get('column') &&
                    <div className="search_result big-text" onClick={() => navigate(decodeURIComponent(path.search) == `?column=${param.get('column')}` ? backlink : `${decodeURIComponent(path?.search)?.replace(`column=${param.get('column')}&`, ``)}`)}>column: {param.get('column')} <i className="fa fa-times"></i></div>
                }
                {param.get('order') &&
                    <div className="search_result big-text" onClick={() => navigate(decodeURIComponent(path.search) == `?order=${param.get('order')}` ? backlink : `${decodeURIComponent(path?.search)?.replace(`&order=${param.get('order')}`, ``)}`)}>order: {param.get('order')} <i className="fa fa-times"></i></div>
                }
            </div>
        </div>
    )
}

export default TopOfPages
